import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { tokenParser, getRenewInterval } from "../helpers";
export class ApiRequestGateway {
    constructor(requestService) {
        this.maxRetries = 5;
        this.messageBus = internalMessageBus;
        this.requestService = requestService;
        this.token = "";
        this.reloadTimeout = -1;
        this.retryCount = 0;
        this.recursiveRenew = this.recursiveRenew.bind(this);
    }
    responseMethod(token) {
        this.token = token;
        this.setTokenRenewMessage();
        this.setRenewToken();
        return this.token;
    }
    setTokenRenewMessage() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken, { token: this.token });
    }
    // The exp of the token is 7days. Therefore, renew will rarely happen
    setRenewToken() {
        if (this.token) {
            window.clearTimeout(this.reloadTimeout);
            let parsedToken = tokenParser(this.token);
            let renewInterval = getRenewInterval(parsedToken.exp);
            // TODO: unit tests
            this.reloadTimeout = window.setTimeout(() => {
                this.getAnonymousToken()
                    .catch((err) => new Error(err));
            }, renewInterval);
        }
    }
    getAnonymousToken() {
        return this.requestService
            .getAnonymousToken()
            .then(response => this.responseMethod(response))
            .catch(err => { throw err; });
    }
    recursiveRenew(err, resolve, reject) {
        this.retryCount++;
        if (this.retryCount <= this.maxRetries) {
            setTimeout(() => {
                this.getAnonymousToken()
                    .then(_ => {
                    resolve(this.token);
                })
                    .catch(x => this.recursiveRenew(x, resolve, reject));
            }, 1000);
        }
        else {
            reject(err);
        }
    }
    getToken() {
        if (this.token) {
            return Promise.resolve(this.token);
        }
        if (!this.requestPromise) {
            let ref = this;
            this.requestPromise = new Promise(function (resolve, reject) {
                ref.getAnonymousToken()
                    .then(token => {
                    resolve(ref.token);
                })
                    .catch(err => {
                    ref.recursiveRenew(err, resolve, reject);
                });
            });
        }
        return this.requestPromise;
    }
}
//# sourceMappingURL=ApiRequestGateway.js.map